<template>
  <div class="trainingmanagement">
    <div class="header">
      {{ $t('Education.languages17')}}：
      <el-select v-model="param.trainStatus" clearable :placeholder="$t('Education.languages18')">
        <el-option  v-for="item in trainingstate" :key="item.value"  :label="item.label"  :value="item.value">
        </el-option>
      </el-select>
      <el-input v-model="param.searchValue" clearable placeholder="请输入培训主题、培训对象查询" style="width: 360px;margin:0 30px"></el-input>
      <el-button type="primary" @click="handleCurrentChange(1)">{{ $t('Education.languages01') }}</el-button>
      <el-button type="primary" @click="$router.push('/Education/trainingstatistics')">培训统计</el-button>
      <el-button type="primary" @click="ClickRelease">{{ $t('Education.languages19') }}</el-button>
    </div>

    <div class="content">
      <el-table  :data="trainingData"  :header-cell-style="{ textAlign: 'center' }"  :cell-style="{ textAlign: 'center' }"  v-loading="loading"  style="width: 100%">
        <el-table-column label="序号">
          <template slot-scope="scope" center>
            {{ (param.pageNum - 1) * 10 + scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column prop="trainName" label="培训主题"></el-table-column>
        <el-table-column prop="trainObjName" label="培训对象" :formatter="formattertrainObjName"></el-table-column>
        <el-table-column prop="createBy" label="发布人"></el-table-column>
        <el-table-column prop="createTime" label="发布时间"></el-table-column>
        <el-table-column label="培训状态">
          <template v-slot="scope">
            {{ scope.row.trainStatus==1?'未开始':scope.row.trainStatus==2?'正在进行中':'已结束' }}
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template v-slot="scope">
            <el-popconfirm @confirm="ClickDelete(scope.row)" title="是否确定删除？">
              <span class="operateitem" slot="reference">{{ $t('Education.languages07')}}</span>
            </el-popconfirm>
            <span class="operateitem" @click="$router.push('trainingrelease?isNew=1&trainId='+scope.row.trainId)">{{ $t('Education.languages08') }}</span>
            <span class="operateitem" @click="$router.push('trainingrelease?isNew=2&trainId='+scope.row.trainId)">{{ $t('Education.languages09') }}</span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination hide-on-single-page @current-change="handleCurrentChange" :current-page.sync="param.pageNum" :page-size="param.pageSize" layout="total, prev, pager, next" :total="param.Total">
      </el-pagination>
    </div>
  </div>
</template>
<script>
export default ({
  name:'trainingmanagement',
  data(){
    return{
      loading:true,
      param:{
        pageNum:1,
        pageSize:10,
        trainStatus:'',
        searchValue:'',
        Total:0
      },
      trainingstate:[{
        value: 1,
        label: '未开始'
      }, {
        value:2,
        label: '正在进行'
      }, {
        value:3,
        label: '已结束'
      }],

      trainingData:[],

    }
  },
  created() {
    this.list();
  },

 
  beforeRouteLeave(to, from, next) {
    if (to.name == "trainingrelease") {
      this.$route.meta.keepAlive = false
    } else {
      this.$route.meta.keepAlive = true
    }
    next();
  },


  methods:{
    // 列表查询
    list(){
      this.loading=true;
      this.$Http_Post('edu/train/list',this.param).then(res=>{
        if(res.Code==0){
          this.loading=false;
          this.param.Total=res.Counts;
          this.trainingData=res.Data;
        }
      });
    },
    formattertrainObjName(row){
      return row.trainObjName.toString();
    },
    // 分页
    handleCurrentChange(val){
      this.param.pageNum=val;
      this.list();
    },
    // 发布
    ClickRelease(){
      this.$cookies.set('releaseclear',0);//清空
      this.$router.push('/Education/trainingrelease?isNew=0');
    },
    // 删除
    ClickDelete(data){
      this.$Http_Post('edu/train/remove/'+data.trainId).then(res=>{
        if(res.Code==0){
          this.list();
          this.$message({type: 'success', message: res.Message});
        }else{
          this.$message({type: 'error', message: res.Message});
        }
      });
    }
  },
  components:{

  }
})
</script>
<style scoped>
.header{display: flex;align-items:center;background: #fff;padding:20px 30px;}
.content{background:#fff;padding:30px;margin-top:20px;}
.operateitem{padding: 0 5px 0 0;color:#0088ff;cursor: pointer}
</style>